const Config = {
  endPoint: 'https://api.spina.virtueanalytics.com/api/',//'https://tech.virtueanalytics.com/ocr-api/',
  endPointProd: 'https://api.spina.virtueanalytics.com/api/'

}


export default Config;